<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
      </div>
      <Navbar />
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
        <h2 class="text-xl font-semibold">Manage Staff</h2>
      </header>

      <main class="p-6 flex-1">
        <div class="bg-gray-800 p-6 rounded-xl shadow-md flex flex-col h-full">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">Staff Accounts</h3>

            <!-- Search Input -->
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search staff..."
              class="px-3 py-2 rounded-md bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring focus:ring-blue-500"
            />
          </div>

          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-700">
                <th class="p-3 rounded-tl-lg">ID</th>
                <th class="p-3">Name</th>
                <th class="p-3">Email</th>
                <th class="p-3">Role</th>
                <th class="p-3">Status</th>
                <th class="p-3 rounded-tr-lg">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="staff in filteredStaff"
                :key="staff.id"
                class="border-t border-gray-700 hover:bg-gray-700 transition"
              >
                <td class="p-3 font-semibold">#{{ staff.id }}</td>
                <td class="p-3">{{ staff.name }}</td>
                <td class="p-3">{{ staff.email }}</td>
                <td class="p-3">{{ staff.role }}</td>
                <td class="p-3">{{ staff.status }}</td>
                <td class="p-3 flex space-x-2">
                  <button
                    @click="deleteStaff(staff.id)"
                    class="px-3 py-1 bg-red-600 rounded-lg hover:bg-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>

              <!-- No results row -->
              <tr v-if="filteredStaff.length === 0">
                <td colspan="6" class="text-center py-4 text-gray-400">
                  No staff accounts found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios';

export default {
  name: "AdminManageStaff",
  components: { Navbar },
  data() {
    return {
      staffList: [],
      searchQuery: ""
    };
  },
  computed: {
    filteredStaff() {
      if (!this.searchQuery) return this.staffList;
      const query = this.searchQuery.toLowerCase();
      return this.staffList.filter(staff =>
        String(staff.id).includes(query) ||
        (staff.name && staff.name.toLowerCase().includes(query)) ||
        (staff.email && staff.email.toLowerCase().includes(query)) ||
        (staff.role && staff.role.toLowerCase().includes(query)) ||
        (staff.status && staff.status.toLowerCase().includes(query))
      );
    }
  },
  async created() {
    await this.fetchStaff();
  },
  methods: {
    async fetchStaff() {
      try {
        const { data } = await axios.get(
          'https://api.syniac.com:3000/api/admin/staff/get',
          { withCredentials: true }
        );
        this.staffList = data.staff;
      } catch (err) {
        console.error("Error fetching staff:", err);
      }
    },
    async deleteStaff(staffId) {
      if (!confirm("Are you sure you want to delete this staff account?")) return;
      try {
        await axios.delete(
          `https://api.syniac.com:3000/api/admin/staff/delete/${staffId}`,
          { withCredentials: true }
        );
        this.staffList = this.staffList.filter(s => s.id !== staffId);
      } catch (err) {
        console.error("Error deleting staff:", err);
      }
    }
  }
};
</script>
